/**
 * Constants
 * Use WS_ namespace
 */

/**
 * Constant for table scroll selectors
 * @type {string}
 */
export const WS_TABLE_SELECTOR = '.table-block';
